// extracted by mini-css-extract-plugin
export var button = "_bf-4";
export var hasDarkBackground = "_bf-7";
export var hasLightBackground = "_bf-6";
export var iconWrapper = "_bf-0";
export var large = "_bf-2";
export var medium = "_bf-1";
export var small = "_bf-5";
export var xsmall = "_bf-3";